export const formatMoney = (amount: number): string => {
  const settings = window.themeVariables?.settings;
  const withCode = settings?.currencyCodeEnabled === true;
  const template = withCode
    ? settings?.moneyWithCurrencyFormat || "${{amount}} AUD"
    : settings?.moneyFormat || "${{amount}}";

  const cents = Math.round(amount * 100);
  const match = template.match(/\{\{\s*([^\s}]+)\s*\}\}/);
  const token = match ? match[1] : "amount";

  const numberWithSeparators = (
    valueCents: number,
    decimals: number,
    thousands: string,
    decimal: string,
  ): string => {
    if (decimals === 0) {
      const major = Math.round(valueCents / 100);
      return major.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    }
    const major = Math.floor(valueCents / 100);
    const minor = Math.abs(valueCents % 100)
      .toString()
      .padStart(2, "0");
    const intPart = major
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return `${intPart}${decimal}${minor}`;
  };

  const formatted = (() => {
    switch (token) {
      case "amount_no_decimals":
        return numberWithSeparators(cents, 0, ",", ".");
      case "amount_with_comma_separator":
        return numberWithSeparators(cents, 2, ".", ",");
      case "amount_no_decimals_with_comma_separator":
        return numberWithSeparators(cents, 0, ".", ",");
      case "amount_with_space_separator":
        return numberWithSeparators(cents, 2, " ", ",");
      case "amount_no_decimals_with_space_separator":
        return numberWithSeparators(cents, 0, " ", ",");
      case "amount_with_apostrophe_separator":
        return numberWithSeparators(cents, 2, "'", ".");
      case "amount":
      default:
        return numberWithSeparators(cents, 2, ",", ".");
    }
  })();

  return template.replace(/\{\{\s*[^\s}]+\s*\}\}/, formatted);
};

export const parseMoneyTextToCents = (text: string): number | null => {
  const cleaned = text?.trim().replace(/[^\d.,-]/g, "") || "";
  if (!cleaned) return null;

  const normalized =
    cleaned.includes(",") && cleaned.includes(".")
      ? cleaned.replace(/,/g, "")
      : cleaned.replace(/,(?=\d{2}(?!\d))/g, ".");

  const num = Number.parseFloat(normalized);
  if (!Number.isFinite(num)) return null;
  return Math.max(0, Math.round(num * 100));
};

export const centsToMajorString = (cents: number): string => {
  const value = Number.isFinite(cents) ? Math.max(0, cents) : 0;
  return (value / 100).toFixed(2);
};
